import React from 'react';
import { getScoreColor } from '../utils';

export interface PropertyStat {
  id: string;
  name: string;
  callCount: number;
  avgScore: number | null;
  tourRate: number | null;
  trend: number | null;
}

interface PropertyPerformanceProps {
  propertyStats: PropertyStat[];
  maxRows: number;
  onSelectProperty: (id: string | null) => void;
}

export const PropertyPerformance: React.FC<PropertyPerformanceProps> = ({
  propertyStats,
  maxRows,
  onSelectProperty
}) => (
  <div className="col-span-2 bg-white rounded-xl shadow-sm border border-gray-100" data-tour="property-performance-table">
    <div className="p-5 border-b border-gray-100">
      <h2 className="font-semibold text-gray-800">Property Performance</h2>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            <th className="px-5 py-3">Property</th>
            <th className="px-5 py-3 text-center">Calls</th>
            <th className="px-5 py-3 text-center">Avg Score</th>
            <th className="px-5 py-3 text-center">Tour Rate</th>
            <th className="px-5 py-3 text-center">Trend</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-50">
          {propertyStats.slice(0, maxRows).map(prop => (
            <tr
              key={prop.id}
              className="hover:bg-gray-50 cursor-pointer transition-colors"
              onClick={() => onSelectProperty(prop.id)}
            >
              <td className="px-5 py-3">
                <p className="font-medium text-gray-800">{prop.name}</p>
              </td>
              <td className="px-5 py-3 text-center text-gray-600">{prop.callCount}</td>
              <td className="px-5 py-3 text-center">
                {prop.avgScore !== null ? (
                  <span className="font-semibold" style={{ color: getScoreColor(prop.avgScore) }}>
                    {prop.avgScore.toFixed(0)}
                  </span>
                ) : (
                  <span className="text-gray-400">—</span>
                )}
              </td>
              <td className="px-5 py-3 text-center text-gray-600">
                {prop.tourRate !== null ? `${prop.tourRate.toFixed(0)}%` : '—'}
              </td>
              <td className="px-5 py-3 text-center">
                {prop.trend !== null ? (
                  <span className={prop.trend >= 0 ? 'text-green-600' : 'text-red-600'}>
                    {prop.trend >= 0 ? '↑' : '↓'} {Math.abs(prop.trend).toFixed(0)}
                  </span>
                ) : (
                  <span className="text-gray-400">—</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div className="p-4 border-t border-gray-100 text-center">
      <button
        onClick={() => onSelectProperty(null)}
        className="text-sm text-gray-500 hover:text-gray-800 font-medium"
      >
        View all properties →
      </button>
    </div>
  </div>
);
